// export type Target = '_self' | '_blank';

export enum Target {
  SELF = '_self',
  BLANK = '_blank',
}

export const targetKeys = Object.keys(Target);
export const targetValues = targetKeys.map((target) => Target[target]);

export interface Multilink {
  src: string;
  target?: Target;
}

export function isMultilink(value: any): value is Multilink {
  return value && typeof value.src === 'string';
}
